import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-mist text-ink" data-id="element-0" data-mp="3ihv0wb3a2fha">
      <MetaPixel data-id="element-1" data-mp="3mjzrt22ccy08" />
      <main data-id="element-2" data-mp="3mjga9mglsbmq">
        <Hero data-id="element-3" data-mp="3mj6lg27aoaim" />
        <SocialProof data-id="element-4" data-mp="3rcj7c4kla37o" />
        <Testimonials data-id="element-5" data-mp="3rbzpsoyupgu6" />
        <ProblemSection data-id="element-6" data-mp="3rcsw5otwe4bs" />
        <SystemSection data-id="element-7" data-mp="3reltgdimfc74" />
        <ModulesSection data-id="element-8" data-mp="5os92t1uy7l" />
        <BonusSection data-id="element-9" data-mp="4wxfu7a14id" />
        <UrgencySection data-id="element-10" data-mp="5gbgztt38r4" />
        <PricingSection data-id="element-11" data-mp="7stfczkdj46" />
        <MoreResults data-id="element-12" data-mp="2zllen0i82im7" />
        <GuaranteeSection data-id="element-13" data-mp="2zm4xqkjlzd1t" />
        <FAQ data-id="element-14" data-mp="2zmwhmy3ufmc9" />
        <ClosingSection data-id="element-15" data-mp="2zng0qi58cgrv" />
        <SummaryTable data-id="element-16" data-mp="33mf6g4yschkd" />
        <FinalCta data-id="element-17" data-mp="33nq4rp9gox43" />
      </main>
      <Footer data-id="element-18" data-mp="33mylndx1wrup" />
      <PurchaseNotification data-id="element-19" data-mp="33oi1j3esp0vy" />
    </div>;
}